import React, { useMemo } from "react";
import { Row } from "./row";
import { ARIValues, HandleInputChangeRequest, UpdatedARIValue, ValueTypes } from "../types";
import { StyledTableVirtuoso } from "./styles";
import { NAME_TYPE } from "../constants";
import { AriType } from "../../updateForm";

interface Props {
  items: ARIValues[];
  handleQuickUpdate: (
    ticker: string,
    valueType: ValueTypes,
    type: AriType
  ) => void;
  enableEdition: boolean;
  handleInputChange: (props: HandleInputChangeRequest) => void;
  updatedARIValues: UpdatedARIValue;
  isComplement?: boolean;
  customHeight?: string;
  nameType?: NAME_TYPE;
  showAltStyles?: boolean;
  numberOfDays: number;
}

const isTickerVisible = (index: number, items: ARIValues[]): boolean =>
  index === 0 || items[index-1].ticker !== items[index].ticker;

export function calculateInputWidth(numberOfDays: number): number {
  return numberOfDays > 19 ? 50 : 75;
}

export function calculateTableWidth(numberOfDays: number): number {
  const inputWidth = calculateInputWidth(numberOfDays)
  return 290 + (inputWidth * numberOfDays);

}

export const CustomTableVirtuoso = (
  {
    items,
    handleQuickUpdate,
    enableEdition,
    handleInputChange,
    updatedARIValues,
    isComplement,
    customHeight,
    nameType,
    showAltStyles,
    numberOfDays
  }: Props
): React.ReactElement => {
  const tableWidth = useMemo(() => calculateTableWidth(numberOfDays), [numberOfDays]);
  const inputWidth = useMemo(() => calculateInputWidth(numberOfDays), [numberOfDays]);
  return (
    <StyledTableVirtuoso
      data-testid="virtuoso-table"
      style={{
        width: tableWidth,
        height: customHeight || "405px",
        marginBottom: "25px",
        overflowY: "scroll"
      }}
      fixedItemHeight={23}
      lite={showAltStyles}
      totalCount={items.length}
      data={items}
      itemContent={index =>
        <Row
          key={index}
          ticker={items[index].ticker}
          name={items[index].name}
          parentTicker={items[index].parentTicker}
          formula={items[index].formula}
          dailySet={items[index].dailySet}
          valueType={items[index].valueType}
          type={items[index].type}
          handleQuickUpdate={handleQuickUpdate}
          enableEdition={enableEdition}
          handleInputChange={handleInputChange}
          isTickerVisible={isTickerVisible(index, items)}
          isComplement={isComplement}
          nameType={nameType}
          disabled={items[index].isChild}
          updatedARIValues={
            updatedARIValues[items[index].ticker]
            && updatedARIValues[items[index].ticker][items[index].valueType]
          }
          showAltStyles={showAltStyles}
          inputWidth={inputWidth}
        />
      }
    />
  );
}
